<template>
  <v-combobox
    v-model="selectedList"
    :items="items"
    :search-input.sync="search"
    hide-selected
    :multiple="multiple"
    :disabled="role != 'superadmin'"
    :label="label"
    deletable-chips
    persistent-hint
    small-chips
    @change="$emit('update:organization', selectedList)"
  >
    <template #no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            No results matching "<strong>{{ search }}</strong>". Press <kbd>enter</kbd> to create a new one
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { ref, watch } from '@vue/composition-api'
// import axios from '@axios'
import gql from 'graphql-tag'

export default {
  name: 'SelectOrganization',
  props: {
    organization: {
      required: false,
      type: [String, Array],
      default: null,
    },
    multiple: {
      required: false,
      type: Boolean,
      default: false,
    },
    label: {
      required: false,
      type: String,
      default: 'Organization',
    },
  },
  apollo: {
    organizations: {
      query: gql`
        query {
          organizations {
            id
            name
          }
        }
      `,
      result(result) {
        this.items = JSON.parse(JSON.stringify(result.data.organizations)).map(org => org.name)
      },
      errorPolicy: 'all',
      error(e) {
        if (e.networkError) this.$toastr.e('Network Error')
        else this.$toastr.e('Server Error')
      },
    },
  },
  setup(props) {
    const items = ref([])
    const selectedList = ref(null)
    const search = ref(null)
    const role = localStorage.getItem('userAbility')

    watch(
      () => props.organization,
      () => {
        selectedList.value = props.organization
      },
    )

    return {
      items,
      selectedList,
      search,
      role,
    }
  },

  mounted() {
    this.$apollo.queries.organizations.refetch()
  },
}
</script>
